exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-7abf1275] {\n  text-align: right;\n  width: auto;\n  margin-left: auto;\n}\n.table th[data-v-7abf1275] {\n  background-color: #666;\n  color: #fff;\n  padding-left: 10px;\n  padding-right: 10px;\n}", ""]);

// exports
